import { ModeComment } from "@mui/icons-material"
import moment from "moment"

function calculateTotalCents(items) {

    let totalCents = 0

    items.forEach(({ itemCostCents, quantity}) => {
        totalCents += (itemCostCents * quantity)
    })

    return totalCents
}

export function setupPurchaseOrderFinalData(formData) {

    let data = {
        ...formData,
        id: parseInt(formData.id),
        job: formData.job ? parseInt(formData.job) : null,
        orderDate: formData.orderDate ? moment(formData.orderDate).format("YYYY-MM-DD") : null
    }
    
    // items to delete
    data['itemsToDelete'] = formData.deleteItems ? formData.deleteItems.map(id => parseInt(id)) : []

    // items to add and update
    let addItems = []
    let updateItems = []
    
    formData.orderItems.forEach(item => {
        if(item.id) {
            let object = {
                id: parseInt(item.id),
                quantity: parseInt(item.quantity),
                itemCostCents: Math.ceil(parseFloat(item.price).toFixed(2) * 100),
                equipment: parseInt(item.equipment.id)
            }

            delete object.__typename
            updateItems.push(object)
        } else {
            let object = {
                quantity: parseInt(item.quantity),
                equipment: parseInt(item.equipment.id),
                itemCostCents: Math.ceil(parseFloat(item.price).toFixed(2) * 100)
            }

            addItems.push(object)
        }
    })
    
    data['itemsToUpdate'] = [...updateItems]
    data['itemsToAdd'] = [...addItems]
    data['totalCents'] = calculateTotalCents([...addItems, ...updateItems])

    return data
}